import { $http } from "@/assets/js/appFunc";

let versionIdPromise = null;
export const getLatestVersionId = (store) => {
    if (!versionIdPromise) {
        versionIdPromise = new Promise((resolve, reject) => {
            $http({
                url: "/engine/api/version/latest",
                type: "GET",
                data: ""
            }, true).then(rsp => {
                store.commit("setLatestVersionId", rsp.data.id);
                resolve(rsp.data.id);
            }).catch(e => {
                reject(e);
            });
        });
    }

    return versionIdPromise;
};
